'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const COISIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="COISIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_806_101970)">
          <path
            d="M7.5 23.5L8 17.5H10.5V14C10.5 12.6739 9.97322 11.4021 9.03553 10.4645C8.09785 9.52678 6.82608 9 5.5 9C4.17392 9 2.90215 9.52678 1.96447 10.4645C1.02678 11.4021 0.5 12.6739 0.5 14V17.5H3L3.5 23.5H7.5Z"
            stroke={sx?.color || 'black'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 4C2 4.45963 2.09053 4.91475 2.26642 5.33939C2.44231 5.76403 2.70012 6.14987 3.02513 6.47487C3.35013 6.79988 3.73597 7.05769 4.16061 7.23358C4.58525 7.40947 5.04037 7.5 5.5 7.5C5.95963 7.5 6.41475 7.40947 6.83939 7.23358C7.26403 7.05769 7.64987 6.79988 7.97487 6.47487C8.29988 6.14987 8.55769 5.76403 8.73358 5.33939C8.90947 4.91475 9 4.45963 9 4C9 3.54037 8.90947 3.08525 8.73358 2.66061C8.55769 2.23597 8.29988 1.85013 7.97487 1.52513C7.64987 1.20012 7.26403 0.942313 6.83939 0.766422C6.41475 0.59053 5.95963 0.5 5.5 0.5C5.04037 0.5 4.58525 0.59053 4.16061 0.766422C3.73597 0.942313 3.35013 1.20012 3.02513 1.52513C2.70012 1.85013 2.44231 2.23597 2.26642 2.66061C2.09053 3.08525 2 3.54037 2 4Z"
            stroke={sx?.color || 'black'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 5.53C12 6.73144 12.4773 7.88366 13.3268 8.7332C14.1763 9.58274 15.3286 10.06 16.53 10.06C17.7314 10.06 18.8837 9.58274 19.7332 8.7332C20.5827 7.88366 21.06 6.73144 21.06 5.53C21.06 4.32857 20.5827 3.17635 19.7332 2.32681C18.8837 1.47727 17.7314 1 16.53 1C15.3286 1 14.1763 1.47727 13.3268 2.32681C12.4773 3.17635 12 4.32857 12 5.53Z"
            stroke={sx?.color || 'black'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M23 12L19.73 8.73" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </svg>
    </SvgIcon>
  )
}

COISIcon.propTypes = {
  sx: PropTypes.object
}
